mutation UpdateInboundWhatsAppRules($input: InboundWhatsAppRulesUpdateInput!) {
    inboundWhatsAppRulesUpdate(input: $input) {
        assignment {
            assignedUser {
                id
                name
            }
        }
    }
}
